

























































































import Vue from "vue";
import { mapState } from "vuex";
import { ATable, AInput } from "@canvas/componentlibrary";
import CellRenderer from "../TableRenderers/NameRenderer.vue";
import { get, post } from "@/api";
import { v4 as uuidv4 } from "uuid";
import store from "@/store";
import { ACTIONS } from "@/consts";
import { getIconForRole } from "@/utils";
export default Vue.extend({
  name: "ManageProducts",
  components: {
    ATable,
    AInput,
  },
  data() {
    return {
      modalWidth: window.innerWidth <= 600 ? '95%' : '600px',
      title: "Product History",
      page: 0,
      pagelength: 10,
      pagecount: 1,
      sortorder: "asc",
      sortby: "customer",
      isModalVisible: false,
      selectedRow: null,
      fileList: [],
      fileUrl: "",
      ACTIONS,
      isLoading: false,
      markAsDeposit: false,
      markAsReject: false,
      data: [],
      comment: "",
      chequeDocId: "",
      chequeDocUrl: "",
      mimeToExt: {
        "image/png": "png",
        "image/jpeg": "jpg",
        "image/gif": "gif",
        "application/pdf": "pdf",
        "text/plain": "txt",
        "application/zip": "zip",
        "application/json": "json",
        "text/html": "html",
      },

      paymentCollectionDataTableColumns: [
        {
          name: "chequeDate",
          display_name: "CHEQUE DATE",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "slugId",
          display_name: "REQUEST ID",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "pid",
          display_name: "PID",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "customerName",
          display_name: "CUSTOMER NAME",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "chequeName",
          display_name: "NAME ON THE CHEQUE",
          width: 15,
          height: 100,
          sortable: true,
          cellrenderer: CellRenderer,
        },
        {
          name: "designerName",
          display_name: "DESIGNER",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "payment_stage",
          display_name: "STAGE",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "paymentMode",
          display_name: "PAYMENT MODE",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "chequeNumber",
          display_name: "CHEQUE NUMBER",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "amount",
          display_name: "AMOUNT",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "collectedOn",
          display_name: "COLLECTED ON",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "depositedOn",
          display_name: "DEPOSITED ON",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "status",
          display_name: "STATUS",
          width: 15,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "comments",
          display_name: "COMMENTS",
          width: 25,
          height: 100,
          cellrenderer: CellRenderer,
        },
        {
          name: "actions",
          display_name: "ACTIONS",
          width: 25,
          height: 100,
          cellrenderer: CellRenderer,
        },
      ],
    };
  },

  computed: {
    ...mapState("uiModule", {
      isOnMobileDevice: "isOnMobileDevice",
    }),
    modalTitle(): string {
      if ((this as any).markAsReject) return "Reject";
      return (this as any).markAsDeposit
        ? "Mark as Deposited"
        : "Mark as Collected";
    },
    isDisabled() {
      if ((this as any).markAsDeposit) {
        return (this as any).comment.length === 0 || (this as any).fileList.length === 0;
      }
      return (this as any).comment.length === 0;
    },
  },
  props: {
    tableData: {
      type: Array,
      required: true,
      default: () => [],
    },
  },
  methods: {
    getIconForRole,
    handleComment(value: any) {
      (this as any).comment = value;
    },
    createTableData() {
      if ((this as any).tableData.length > 0) {
        const constructedTableData = (this as any).tableData.map(
          (each: any) => {
            let cashPayMethod = each.document.pay_method === "CMS_SCB";
            const currentStep = each.current_steps?.[0];
            const seq = currentStep?.sequence;
            const status = !seq
              ? each?.status
              : cashPayMethod
              ? seq > 1
                ? "COLLECTED"
                : "RAISED"
              : seq == 1
              ? "RAISED"
              : seq == 2
              ? "COLLECTED"
              : "DEPOSITED";
            const action = ["APPROVED", "REJECTED"].includes(each?.status)
              ? ""
              : cashPayMethod
              ? seq == 1
                ? "Mark Collected"
                : ""
              : seq == 1
              ? "Mark Collected"
              : seq == 2
              ? "Mark Deposited"
              : "";
            const temp = {
              id: each.id,
              slugId: each.request_slug,
              customerName: each.document.customer_name ?? "-",
              chequeName: each.document.chequeName ?? "- ",
              chequeDate:each.document?.chequeDate ? new Date(each.document.chequeDate).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  ) : "-",
              designerName: each.document.designerName ?? "-",
              payment_stage: each.document.payment_stage ?? "-",
              chequeNumber: cashPayMethod ? "-" :  each.document?.chequeNumber,
              paymentMode: cashPayMethod ? "CMS_SCB" : "CHEQUE",
              amount: each.document.amount,
              collectedOn: each.metadata.collectedOn
                ? new Date(each.metadata.collectedOn).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )
                : "-",
              depositedOn: each.metadata.depositedOn
                ? new Date(each.metadata.depositedOn).toLocaleDateString(
                    "en-GB",
                    {
                      day: "2-digit",
                      month: "short",
                      year: "numeric",
                    }
                  )
                : "-",
              status: status ?? each.status,
              comments: each.document.comment,
              checkCopyLink: "http://example.com/check_copy",
              actions: action,
              tags: each.tags,
              metadata: each.metadata,
              designerId: each.document.designer_id,
              pid: each.document.id_project,
              req_id: each.id,
              step_id: currentStep ? currentStep?.id : "",
              chequeAttachment: each.metadata?.file_id,
              depostAttachment: each.metadata.chequeDocId,
              file_id: each.metadata.file_id,
            };

            return temp;
          }
        );
        (this as any).data = constructedTableData;
      }
    },
    onFileInputChange(event: any) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        (this as any).file = selectedFile;
        (this as any).filePreview = URL.createObjectURL(selectedFile);
        (this as any).handleFileUpload(selectedFile);
      }
    },
    async getPaymnetDocFolderId(pid: any) {
      let folderId = "";
      const foldersList: any = await get({
        endpoint: "sales.storage.api.v2.folderslist",
        body: {
          pid: pid,
        },
      });
      if (!foldersList.error) {
        let folder = foldersList.response?.filter(
          (eachFolder: any) => eachFolder.display_name === "Payment docs"
        );
        if (folder?.length > 0) {
          folderId = folder[0].folder_id;
        } else {
          const payload = {
            folders: [
              {
                context_type: "project",
                context_id: pid,
                display_name: "Payment docs",
                type: "custom",
              },
            ],
          };
          const createdFolderResponse: any = await post({
            endpoint: "sales.storage.api.v2.folders",
            payload: payload,
          });
          if (!createdFolderResponse.error) {
            folderId = createdFolderResponse[0].folder_id;
          }
        }
      }
      return folderId;
    },
    async uploadFile(res: any, row: any, fileName: string, url: string) {
      if (res.id) {
        const folderId = await (this as any).getPaymnetDocFolderId(row.pid);
        const filePayload = {
          files: [
            {
              display_name: fileName,
              source: "s3_upload",
              type: "custom_custom",
              url: url,
            },
          ],
        };

        const uploadFileResponse: any = await post({
          endpoint: "sales.storage.api.v2.folders.:folderId.files",
          body: {
            folderId,
            payload: filePayload,
          },
        });

        if (!uploadFileResponse.error) {
          if (!uploadFileResponse.error) {
            (this as any).chequeDocId = uploadFileResponse.response[0].id;
            (this as any).chequeDocUrl = uploadFileResponse.response[0].url;
            await (this as any).postApprovalRequest();
          }
        }
      }
    },
    async addAttachment(path: any, fileName: string, file: any) {
      post({
        endpoint: "core.workflow.api.v1.request.id.attachment",
        body: {
          url: path,
          entity_id: (this as any).selectedRow.step_id,
          type: "STEP",
          name: fileName,
        },
      })
        .then(async (res: any) => {
          if (!res.id) {
            throw new Error("Error in Uploading attachment");
          } else {
            const fileUuid = uuidv4();
            const fileExtension = (this as any).mimeToExt[file.type];
            const launchpadBackendRes: any = await post({
              endpoint: "launchpad-backend.v1.tmp",
              body: {
                file,
                fileUuid,
                fileExtension,
              },
            });
            if (launchpadBackendRes.file_url) {
              const url: any = launchpadBackendRes.file_url;
              (this as any).uploadFile(
                res,
                (this as any).selectedRow,
                fileName,
                url
              );
            }
          }
        })
        .catch((err) => {});
    },
    updateUniqueFileName(fileName:any) {
      if (!fileName) {
          return '';
      }
      fileName = fileName.trim();
      let currentTimeStamp = new Date().getTime(),
          fileParts = fileName.split('.');
      let fileExtension = fileParts?.length > 1 ? '.' + fileParts.pop() : '',
          baseFileName = fileParts?.join('.').replace(/\s+/g, '_');
      return baseFileName + '_' + currentTimeStamp + fileExtension;
    },
    async getFileUploadedUrl(file: any) {
      if (!file) return;
      try {
        (this as any).isLoading = true;
        const uniqueFileName = (this as any).updateUniqueFileName(file.name);
        const preSignedUrlRes: any = await get({
          endpoint: "infra.common.api.v2.presignedUrlUpload",
          fileName: uniqueFileName,
        });

        if (preSignedUrlRes.presigned_url) {
          (this as any).fileUrl = preSignedUrlRes.path;
          const uploadResponse = await fetch(preSignedUrlRes.presigned_url, {
            method: "PUT",
            body: JSON.stringify(file),
            headers: {
              "Content-Type": "application/json",
            },
          });
          if (!uploadResponse.ok) {
            throw new Error("Error in validation");
          }
          (this as any).addAttachment(preSignedUrlRes.path, uniqueFileName, file);
        }
      } catch (error) {
        throw new Error(` ${error.message} Error in validation`);
      }
    },
    handleModalCancel() {
      (this as any).isModalVisible = false;
      (this as any).markAsReject = false;
      (this as any).selectedRow = null;
      (this as any).fileList = [];
    },
    async handleModalApprove() {
      (this as any).isLoading = true;
      if ((this as any).fileList.length > 0)
        await (this as any).getFileUploadedUrl((this as any).fileList[0]);
      else await (this as any).postApprovalRequest();
    },
    async postApprovalRequest() {
      try {
        const metadata: any = {
          ...((this as any).markAsDeposit
            ? { depositedOn: new Date() }
            : { collectedOn: new Date() }),
        };

        if ((this as any).chequeDocId) {
          metadata.chequeDocId = (this as any).chequeDocId;
          metadata.chequeDocUrl = (this as any).chequeDocUrl;
        }
        (this as any).isLoading = false;

        const payload = {
          tags: [
            `PID:${(this as any).selectedRow.pid}`,
            `ec:${store.state.appModule.selectedEc?.name}`,
          ],
          metadata,
        };

        await post({
          endpoint: "core.workflow.api.v1.requests.id.steps.id.approve",
          body: {
            payload,
            req_id: (this as any).selectedRow.id,
            step_id: (this as any).selectedRow.step_id,
          },
        });

        await (this as any).addComment();
        (this as any).$emit("refetchData");
        (this as any).closeModal();
      } catch (error) {
        (this as any).closeModal();
      }
    },
    async handleReqReject() {
      await post({
        endpoint: "core.workflow.api.v1.requests.id.steps.id.reject",
        body: {
          tags: [""],
          ecId: `${store.state.appModule.selectedEc?.name}`,
          designerId: (this as any).selectedRow.designerId,
          pid: (this as any).selectedRow.pid,
          req_id: (this as any).selectedRow.id,
          step_id: (this as any).selectedRow.step_id,
        },
      }).then(async (response) => {
        await (this as any).addComment();
        (this as any).$emit("refetchData");
        (this as any).closeModal();
      });
    },
    async addComment() {
      post({
        endpoint: "core.workflow.api.v1.requests.id.comments",
        body: {
          entity_type: "STEP",
          entity_id: (this as any).selectedRow.step_id,
          comment: (this as any).comment,
        },
      }).then((response) => {});
    },
    handleFileUpload(event: any) {
      const file = event.target.files[0];
      if (file) {
        (this as any).fileList.push(file);
      }
    },

    closeModal() {
      (this as any).isModalVisible = false;
      ((this as any).comment = ""), ((this as any).isLoading = false);
      (this as any).markAsReject = false;
      (this as any).selectedRow = null;
      (this as any).markAsDeposit = false;
      (this as any).fileList = [];
    },

    async handleTableAction(actionType: any, data: any) {
      switch (actionType) {
        case "reject":
          (this as any).markAsReject = true;
          break;
        case "rowselect":
          break;
        case "markAsCollected":
          {
            (this as any).markAsDeposit = false;
          }
          break;
        case "markAsDeposited": {
          (this as any).markAsDeposit = true;
        }
      }
      if (actionType !== "rowselect") {
        (this as any).selectedRow = data;
        (this as any).isModalVisible = true;
      }
    },
    updateModalWidth() {
      (this as any).modalWidth = window.innerWidth <= 600 ? '95%' : '600px';
    }
  },
  mounted() {
    window.addEventListener("resize", (this as any).updateModalWidth);
    (this as any).createTableData();
  },
  beforeDestroy() {
  window.removeEventListener("resize", (this as any).updateModalWidth);
  },
  provide() {
    return {
      actionHandler: (this as any).handleTableAction.bind(this),
    };
  },
  watch: {
    tableData: {
      handler(newVal) {},
      deep: true,
    },
  },
});
